import { createStandardAction } from "typesafe-actions";
import { InvoiceCSVHeaders, InvoiceData } from "./types";
import { requestActionCreator } from "../../actionCreators";
import { APIRequestConfig } from "../../types";

export const openInvoiceCSVModal = createStandardAction(
  "@invoicing/openInvoiceCSVModal"
)();

export const cancelUploadInvoiceCSV = createStandardAction(
  "@invoicing/cancelUploadInvoiceCSV"
)();

export const selectInvoiceCSVHeaders = createStandardAction(
  "@invoicing/selectInvoiceCSVHeaders"
)<Partial<InvoiceCSVHeaders>>();

export const loadInvoiceCSVData = createStandardAction(
  "@invoicing/loadInvoiceCSVData"
)<string[][]>();
export const unloadInvoiceCSVData = createStandardAction(
  "@invoicing/unloadInvoiceCSVData"
)();

export const getInvoiceDataRequest = () => {
  return requestActionCreator("@invoicing/getInvoiceData")({
    request: {
      url: "/invoices",
      method: "GET",
    },
  });
};
export const getInvoiceDataSuccess = createStandardAction(
  "@invoicing/getInvoiceDataSuccess"
)<InvoiceData[], { originalRequest: APIRequestConfig }>();

export const saveInvoiceCSVDataRequest = (payload: InvoiceData[]) => {
  return requestActionCreator("@invoicing/saveInvoiceCSVData")({
    request: {
      url: "/invoices",
      method: "POST",
      mock: {
        status: 201,
        body: {
          data: [
            {
              id: 123,
              invoice_number: "ABC123",
              amount: 123,
              invoice_date: "2020-01-01T08:00:00Z",
              due_date: "2020-01-01T08:00:00Z",
              client_name: "Mr Example",
              client_email: "example@test.com",
              client_phone_number: "07123123123",
              comments: "something something",
            },
          ],
        },
      },
      payload,
    },
  });
};
export const saveInvoiceCSVDataPending = createStandardAction(
  "@invoicing/saveInvoiceCSVDataPending"
)();
export const saveInvoiceCSVDataError = createStandardAction(
  "@invoicing/saveInvoiceCSVDataError"
)();
export const saveInvoiceCSVDataSuccess = createStandardAction(
  "@invoicing/saveInvoiceCSVDataSuccess"
)<InvoiceData[], { originalRequest: APIRequestConfig }>();
